import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import {
  Typography,
  IconButton,
  Box,
  Stack,
  Badge,
  Menu,
  MenuItem,
  List,
  ListItem,
  ListItemText,
  Collapse,
  useMediaQuery,
  Drawer,
  Divider,
} from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import BookIcon from "@mui/icons-material/Book";
import MenuIcon from "@mui/icons-material/Menu";
import ExpandMore from "@mui/icons-material/ExpandMore";
import ExpandLess from "@mui/icons-material/ExpandLess";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import ChartDialog from "../checkout/Chartdialog";
import LoginDialog from "../register_login/LoginDialog";
import { Mycontext } from "../../mycontext";
import { useNavigate } from "react-router-dom"; // React Router yönlendirme

const styles = theme => ({
  appBar: {
    boxShadow: theme.shadows[6],
  },
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
  },
  menuButtonText: {
    fontSize: theme.typography.body1.fontSize,
    fontWeight: theme.typography.h6.fontWeight
  },
  brandText: {
    fontFamily: "'Baloo Bhaijaan', cursive",
    fontWeight: 400
  },
  noDecoration: {
    textDecoration: "none !important"
  },
  typography:{
  fontSize:{xs:4, sm:4, md:14 }, 
  fontFamily:"'Baloo Bhaijaan', cursive", 
  fontWeight:{xs:200, md:400}
  }

});

function NavBar(props) {
  const {
    data
  } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const [submenuItems, setSubmenuItems] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false); // Drawer kontrolü
  const [isLoginDialogOpen, setIsLoginDialogOpen] = useState(false); // Login Dialog State
  const [isVisible, setIsVisible] = useState(true); // sub_main1 ve sub_main2 görünürlüğü
  const navigate = useNavigate(); // Navigasyon için hook
  const [submenuOpen, setSubmenuOpen] = useState({});
  const [scrollPosition, setScrollPosition] = useState(0); // Scroll pozisyonu takibi
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const context = useContext(Mycontext);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.pageYOffset;

      // Ekran kaydırıldığında sub_main1 ve sub_main2'yi gizle
      if (currentScrollPos > 100) {
        setIsVisible(false); // 100 piksel üzerinde görünürlüğü kaldır
      } else {
        setIsVisible(true); // 100 piksel altındaysa görünür yap
      }

      setScrollPosition(currentScrollPos);
    };

    // Kaydırma olayını dinle
    window.addEventListener("scroll", handleScroll);

    // Temizlik (component unmount sırasında)
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  if (!context) {
    
    return null;
  }
  
  const { isFavoriteVisible, setIsFavoriteVisible, cartItemsCount, setCartItemsCount,cartItemsData, setCartItemsData } = context;
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [isChartDialogOpen, setIsChartDialogOpen] = useState(false);

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    
    if(window.localStorage.getItem('chart'))
    {
      let chart= JSON.parse(window.localStorage.getItem('chart'))
      setCartItemsCount(chart.length)
      setCartItemsData(chart)
    }
    if(cartItemsData.length >0)
    {
     setCartItemsCount(cartItemsData.length)
    }
    
  }, []);


  const handleCartClick = () => {
    if(cartItemsData.length>0){
       setIsChartDialogOpen(true);}
      } 


  const handleCloseChartDialog = () => {
   
    setIsChartDialogOpen(false);
  };

  const handleMenuOpen = (event, submenu) => {
    setAnchorEl(event.currentTarget);
    setSubmenuItems(submenu); // Alt menü öğelerini ayarla
  };
  
  const handleMenuClose = (key) => {
    if (key !=='' && key !== 'Etusivu'){
      localStorage.setItem('filter',key)
    }
    setAnchorEl(null);
    setSubmenuItems(null); // Alt menü öğelerini sıfırla

  };

  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };

  const toggleSubmenu = (name) => {
    setSubmenuOpen((prev) => ({
      ...prev,
      [name]: !prev[name],
    }));
  };

  if(localStorage.getItem('fav') && data.length>0)
    {
      
    
      let temp = data.map(el => el.id)
 
      if (temp.length>0)
        {
          setIsFavoriteVisible(true)
        } 
      else
        {
          localStorage.removeItem('fav')
        }  
      }
  
  const menuItems = [
    {
      link: "/",
      name: "Etusivu",
      icon: <HomeIcon className="text-white" />
    },
    {
      link: "/products?filter=Sohvat",
      name: "Sohvat",
      icon: <BookIcon className="text-white" />,
      submenu: {
        'Kulmasohvat': "/products?filter=Kulmasohvat",
        'Vuodesohvat': "/products?filter=Vuodesohvat",
        'Divaanisohvat': "/products?filter=Divaanisohvat",
        '2-3 istuttavat sohvat': "/products?filter=2-3 istuttavat sohvat",
        'Nojatuolit': "/products?filter=Nojatuoli",
        "Kaikki Sohvat": "/products?filter=Kaikki Sohvat",
      },
    },
    {
      link: "/products",
      name: "Sängyt",
      icon: <BookIcon className="text-white" />
    },
    {
      link: "/products",
      name: "Matot",
      icon: <BookIcon className="text-white" />
    },
    {
      link: "/products",
      name: "Uudet Huonekalut",
      icon: <BookIcon className="text-white" />
    },
    {
      link: "/products",
      name: "Muut",
      icon: <BookIcon className="text-white" />
    },
    {
      link: "/blogi",
      name: "Palvelut",
      icon: <BookIcon className="text-white" />
    },
  ];

  
  return (
     <> <Box sx={{display:{xs:'none',md:'block'}}}>
        <Box key='main_box' sx={{position:'fixed',display:'flex', top:0, ml:{sm:0,lg:5},p:1,zIndex:1000,backgroundColor:'white',width:{sm:'98%', lg:'90%'}}} >
        <Box key='sub_main1_box'  width='8%' display='flex' justifyContent='center' sx={{flexDirection:'row', display:scrollPosition>250?'none':'block'}}>
        <Box   display='flex' justifyContent='center'sx={{flexDirection:'column'}} >
          <img
            src={`${process.env.PUBLIC_URL}/logo_5.png`}
            alt="Logo"
            style={{ width:60 , marginLeft:10}}
            onClick={() => {navigate("/")}}
          />
          <Typography onClick={() => {navigate("/")}} sx={{display:{xs:'none', md:'block', color:'#d32f2f'}}} variant='h5'  > Ehankki </Typography>
        </Box>
        </Box>
      <Box key={'sub_main2_box'} sx={{ width:'92%',display: 'flex', flexDirection:'column',ml:scrollPosition>250?'8%':0}}>
        <Box key={'sub_main2_1_box'}sx={{ width:'100%', backgroundColor: '#f8f9fa', height: '30px', alignContent:'center',display:scrollPosition>250?'none':'block'}}>
            <Stack direction='row' justifyContent='space-between'>
           
            <Typography  sx={{display:{xs:'none', md:'block'}}} variant='body2'  > Niittyläntie 3, 00620 Helsinki </Typography>
            <Typography variant='body2'> Avoin ma-la 11:00 - 18:00   su 12:00 -17:00 </Typography>
            <Typography variant='body2'>041 312 4969</Typography>
            </Stack>
        </Box>
        <Box key={'sub_main2_1_box'} display='flex' flexDirection='row' justifyContent='space-between'  sx={{ width:'100%', height: '50px'}}>
            <Stack direction='row' spacing={3} justifyContent='flex-start' alignItems='flex-end'>
             {menuItems.map(element => {
                if (element.link) {
                    return (
                      <Typography
                      key={element.name}
                      variant="h5"
                      sx={{ color: '#d32f2f', cursor: 'pointer',
                        textDecoration: 'none', // Alt çizgiyi kaldırır
                        '&:hover': {
                          textDecoration: 'underline', 
                          color:'#37474f'
                       }}}
                      component={element.submenu?'':'a'}
                      href={element.submenu?' ':element.link}
                      onClick={(event) => element.submenu ? handleMenuOpen(event, element.submenu) : handleMenuClose(element.name)}
                    >
                      {element.name}
                    </Typography>
                    );
                }})}
                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={() => handleMenuClose('')}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                  }}
                >
                  {submenuItems &&
                    Object.entries(submenuItems).map(([key, link]) => (
                      <MenuItem key={key} onClick={() => handleMenuClose(key)}>
                        <Typography variant="body2" component="a" href={link} sx={{ textDecoration: 'none', color: 'inherit' }}>
                          {key}
                        </Typography>
                      </MenuItem>
                    ))}
                </Menu>
            </Stack>
            <Stack display='flex' flexDirection='row' alignItems='flex-end'>
                {isFavoriteVisible && <Link to='/fav'> <Box >
                <IconButton aria-label="delete"
                size='large' 
                >
                <FavoriteBorderIcon/>
                </IconButton>
                </Box> </Link>
                }
                <Box >
                <IconButton aria-label="delete"
                size='large' 
                onClick={handleCartClick}
                >
                <Badge badgeContent={cartItemsCount} color='error'>
                <ShoppingCartIcon color='info'/>
                </Badge>
                </IconButton>
                </Box>
                <IconButton
                  aria-label="login"
                  size="large"
                  onClick={() => setIsLoginDialogOpen(true)} // Login Dialog Açma
                >
                  <PersonOutlineIcon color='error' size='large' />
                </IconButton>
            </Stack>
        </Box>
      </Box>
      <ChartDialog open={isChartDialogOpen} onClose={() => handleCloseChartDialog()} data={data} />
      </Box>
      </Box>
         {/* Login Dialog */}
         <LoginDialog
        open={isLoginDialogOpen}
        onClose={() => setIsLoginDialogOpen(false)}
      />
    {/* -----------------Mobil ve Masaüstü için Ortak Yapı --------------*/}
    <Box
      sx={{
        position: "sticky",
        top: 0,
        zIndex: 1000,
        backgroundColor: "white",
        display: {xs:'flex',md:'none'},
        justifyContent: "space-between",
        alignItems: "center",
        padding: 1,
      }}
    >
      {/* Logo */}
      <Stack direction='row'>
      <img
        src={`${process.env.PUBLIC_URL}/logo_5.png`}
        alt="Logo"
        style={{ width: 60, display: isMobile ? "block" : "none" }}
        onClick={() => {navigate("/")}}
      />
      <Typography  onClick={() => {navigate("/")}} sx={{ color:'#d32f2f'}} variant='h4' fontWeight={500} >ankki Kaluste </Typography>
      </Stack>
      {/* Menü İkonu (Mobil) */}
      <Stack display='flex' flexDirection='row' alignItems='flex-end'>
        {isFavoriteVisible && <Link to='/fav'> <Box >
        <IconButton aria-label="delete"
        size='large' 
        >
        <FavoriteBorderIcon/>
        </IconButton>
        </Box> </Link>
        }
        <Box >
        <IconButton aria-label="delete"
        size='large' 
        onClick={handleCartClick}
        >
        <Badge badgeContent={cartItemsCount} color='error'>
        <ShoppingCartIcon color='info'/>
        </Badge>
        </IconButton>
        </Box>
        <Box >
        <IconButton onClick={toggleDrawer(true)}>
          <MenuIcon />
        </IconButton>
        </Box>
    </Stack>
    </Box>

    {/* Drawer (Mobil Menü) */}
    <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer(false)}>
      <Box sx={{ width: 250, padding: 2 }}>
        <List>
        <ListItem >
            <ListItemText  primary={'Menu'} primaryTypographyProps={{color:'error',variant:'h5'}}/>
        </ListItem>
        <Divider color="black" variant='fullWidth' component="li" />
          {menuItems.map((item, index) => (
            <div key={index}>
              <ListItem  button onClick={() => item.submenu ? toggleSubmenu(item.name):handleMenuClose(item.name)}
                component= {item.submenu ?'':'a'}
                href={item.submenu ? ' ':item.link}>
                <ListItemText  primary={item.name} primaryTypographyProps={{color:'#37474f', href:item.link}}/>
                {item.submenu && (submenuOpen[item.name] ? <ExpandLess /> : <ExpandMore />)}
              </ListItem>
              {/* Alt Menü */}
              {item.submenu && (
                <Collapse in={submenuOpen[item.name]} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    {Object.entries(item.submenu).map(([key, link]) => (
                      <ListItem key={key} button component="a" href={link} onClick={() => handleMenuClose(key)}>
                        <ListItemText primary={key} primaryTypographyProps={{color:'#37474f'}}/>
                      </ListItem>
                    ))}
                  </List>
                </Collapse>
              )}
              <Divider color="black" variant='fullWidth' component="li" />
            </div>
          ))}
        </List>
      </Box>
    </Drawer>
  </>
  );
}

export default NavBar;
